<template>
<div class="chapter">
<div class="inner_page">
<p><a id="p01"></a></p>
<div class="ct"><b> PART I</b></div>
<div class="cst"><b> One of the Great Polluters of Industrial History</b></div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// mari_9781595585363_oeb_p01_r1.vue?d9b6978e